<template lang="pug">
div
	.infosheet
		//- BANNER
		div.many-before.mb-6(style="background-image: url(https://static.wintersport.nl/images/nskiv/currently.jpg); height:145px;")
			.text-center
				.white--text.headline.font-weight-black.px-4.pt-4 351.477 wintersporters gingen je voor!
				.white--text.font-weight-bold.pt-2 - sinds 1978 -

		//- SUMMARY
		v-card.mb-6(outlined color="info")
			//- v-card-title
			//- 	h2 Doorlopende reisverzekering
			v-card-text(v-if="isLoading")
				v-row
					v-col.shrink
						v-progress-circular(indeterminate color="primary")
					v-col Een moment geduld alstublieft ...
			v-card-text(v-else)
				v-list(subheader dense color="#f2fbff")
					v-subheader.font-weight-bold Aantal personen
					v-list-item
						v-list-item-content
							v-list-item-title Volwassenen
						v-list-item-action
							v-list-item-subtitle {{personCount}} pers.
					v-list-item(v-if="request.children")
						v-list-item-content
							v-list-item-title Kinderen
						v-list-item-action
							v-list-item-subtitle {{request.childrenItems.length}} pers.
				v-list(subheader dense color="#f2fbff")
					v-subheader.font-weight-bold Dekking
					//- main
					v-list-item
						v-list-item-content
							v-list-item-title Basis reisverzekering
								hovertag(field="mainCoverage")
						v-list-item-action
							v-list-item-subtitle &euro; {{getCoverage('MAIN').price_month}}
					//- wintersport
					v-list-item
						v-list-item-content
							v-list-item-title Wintersport
								sup plus
								hovertag(field="wintersport")
						v-list-item-action
							v-list-item-subtitle.success--text inclusief
					//- medical
					v-list-item
						v-list-item-content
							v-list-item-title Geneeskundige kosten
								hovertag(field="medical")
						v-list-item-action
							v-list-item-subtitle.success--text inclusief
					//- legal
					v-list-item
						v-list-item-content
							v-list-item-title Rechtsbijstand
								hovertag(field="legal")
						v-list-item-action
							v-list-item-subtitle.success--text inclusief
					//- worldwide
					transition(name="flash")
						v-list-item(v-if="hasCoverage('DR_GEBIED')")
							v-list-item-content
								v-list-item-title Werelddekking
									hovertag(field="worldwide")
							v-list-item-action
								v-list-item-subtitle &euro; {{getCoverage('DR_GEBIED').price_month}}
					//- luggage
					transition(name="flash")
						v-list-item(v-if="hasCoverage('BR')")
							v-list-item-content
								v-list-item-title Bagage
									hovertag(field="luggage")
							v-list-item-action
								v-list-item-subtitle &euro; {{getCoverage('BR').price_month}}
					//- specialSportsUtilities
					transition(name="flash")
						v-list-item(v-if="hasCoverage('SU')")
							v-list-item-content
								v-list-item-title Extra sportuitrusting
									hovertag(field="specialSportsUtilities")
							v-list-item-action
								v-list-item-subtitle &euro; {{getCoverage('SU').price_month}}
					//- accidents
					transition(name="flash")
						v-list-item(v-if="hasCoverage('OD')")
							v-list-item-content
								v-list-item-title Overlijdens- of invaliditeitsuitkering
									hovertag(field="accidents")
							v-list-item-action
								v-list-item-subtitle &euro; {{getCoverage('OD').price_month}}
					//- cancellation
					transition(name="flash")
						v-list-item(v-if="hasCoverage('AN')")
							v-list-item-content
								v-list-item-title Annulering
									hovertag(field="cancellation")
							v-list-item-action
								v-list-item-subtitle &euro; {{getCoverage('AN').price_month}}
					//- carAssistance
					transition(name="flash")
						v-list-item(v-if="hasCoverage('PH')")
							v-list-item-content
								v-list-item-title Pechhulp
									hovertag(field="carAssistance")
							v-list-item-action
								v-list-item-subtitle &euro; {{getCoverage('PH').price_month}}
					//- instructor
					transition(name="flash")
						v-list-item(v-if="hasCoverage('DR_SKILRA')")
							v-list-item-content
								v-list-item-title Clausule skileraar
									hovertag(field="instructor")
							v-list-item-action
								v-list-item-subtitle &euro; {{getCoverage('DR_SKILRA').price_month}}
					//- business
					transition(name="flash")
						v-list-item(v-if="hasCoverage('DA')")
							v-list-item-content
								v-list-item-title Zakenreizen
									hovertag(field="business")
							v-list-item-action
								v-list-item-subtitle &euro; {{getCoverage('DA').price_month}}
				v-list(subheader dense color="#f2fbff")
					v-subheader.font-weight-bold Overige kosten
					//- serviceFee
					v-list-item
						v-list-item-content
							v-list-item-title Lidmaatschap
								hovertag(field="serviceFee")
						v-list-item-action
							v-list-item-subtitle &euro; {{getMembershipCoverage('MEMBRSHP').price_month}}
					//- serviceFee
					v-list-item
						v-list-item-content
							v-list-item-title Poliskosten
								hovertag(field="polisFee")
						v-list-item-action
							v-list-item-subtitle &euro; 0.00
				v-divider
				v-list(color="#f2fbff")
					//- monthly
					v-list-item(v-if="isCalculating")
						v-list-item-content
							v-list-item-title.font-weight-bold Totaal
						v-list-item-action
							v-list-item-subtitle
								v-progress-circular(indeterminate :size="18" :width="2" color="primary")
							small per maand
					v-list-item(v-else)
						v-list-item-content
							v-list-item-title.font-weight-bold Totaal
						v-list-item-action
							v-list-item-subtitle.font-weight-bold &euro; {{totalCalculationPrice.total_month}}
							small.grey--text per maand
					//- yearly
					v-list-item(v-if="isCalculating" dense)
						v-list-item-content
							v-list-item-title Totaal per jaar
						v-list-item-action
							v-list-item-subtitle
								v-progress-circular(indeterminate :size="15" :width="1" color="grey")
					v-list-item(v-else dense)
						v-list-item-content
							v-list-item-title Termijnbedrag totaal
						v-list-item-action
							v-list-item-subtitle &euro; {{totalCalculationPrice.total}}
				v-card-text
					.caption.grey--text Bovengenoemde verzekeringspremie is inclusief assurantiebelasting. Het is verplicht om lid te zijn van de Nederlandse Ski Vereniging om de verzekering te mogen afsluiten. Je betaalt altijd per jaar.
					ul
						li
							a.caption(href="https://download.wintersport.nl/media/downloads/2022/03/31/allianz-polisvoorwaarden-doorlopende-reisverzekering-nsv22-31-03-2022.pdf" target="_blank" rel="nofollow") Polisvoorwaarden
						li
							a.caption(href="https://download.wintersport.nl/media/downloads/2022/11/14/lidmaatschap-algemene-voorwaarden-versie-2022-14-11-2022.pdf" target="_blank" rel="nofollow") Voorwaarden voor het lidmaatschap

	h1 Premie doorlopende reisverzekering berekenen
	v-stepper.flow-left(v-model="step" vertical flat)

		//- STEP 1: PERSONS
		v-stepper-step(:complete="step > 1" step="1" :editable="canEditStep(1)" id="step-1")
			| Verzekerden
			small
				a(v-if="canEditStep(1)" @click="step = 1") wijzig deze stap
		v-stepper-content(step="1")
			v-card(outlined)
				v-card-text
					h2.font-weight-bold.body-2 Verzekerden
					validation-provider(name="Mijzelf" :rules="{ required: { allowFalse: false } }" v-slot="{ errors, touched }")
						v-checkbox(v-model="request.owner" label="Mijzelf" disabled hide-details="auto" :error-messages="touched ? errors : []")
					v-checkbox(v-model="request.partner" label="Partner" hide-details="auto")
					v-checkbox(v-model="request.children" :disabled="request.childrenItems.length > 0")
						template(slot="label") Kind(eren)
							hovertag(field="kids")
					v-card(v-if="request.children" outlined)
						v-card-text
							v-alert.mt-2.caption(v-if="!request.childrenItems.length" text type="warning") Voeg minimaal 1 kind toe.
							v-list.mb-4(v-else two-line)
								v-list-item(v-for="(child, index) in request.childrenItems" :key="index" @click="editChild(index)")
									v-list-item-content
										v-list-item-title Kind {{index + 1}}
										v-list-item-subtitle.caption {{$dayjs(child.gebdat).format('DD-MM-YYYY')}} ({{$dayjs().diff($dayjs(child.gebdat), 'year')}} jaar)
										.caption.grey--text(v-if="$dayjs().diff($dayjs(child.gebdat), 'year') < 5") Tot 5 jaar gratis lidmaatschap en tot 21 jaar gratis meeverzekerd!
										.caption.grey--text(v-else-if="$dayjs().diff($dayjs(child.gebdat), 'year') < 10") Tot 21 jaar oud gratis meeverzekerd! Lidmaatschap slechts €1,46 p/m.
									v-list-item-action
										v-btn(icon @click.stop="removeChild(index)")
											v-icon(small) delete
							v-btn(@click="editChild(-1)" color="primary" outlined) kind toevoegen
				v-card-actions
					v-spacer
					v-btn(color="primary" @click="submitStep()" :disabled="isCalculating || (request.children && !request.childrenItems.length)") verder naar dekking
						v-progress-circular.ml-2(v-if="isCalculating" right indeterminate :size="15" :width="1" color="grey")

		//- STEP 2: COVERAGES
		v-stepper-step(:complete="step > 2" step="2" :editable="canEditStep(2)" id="step-2")
			| Dekking
			small
				a(v-if="canEditStep(2)" @click="step = 2") wijzig deze stap
		v-stepper-content(step="2")
			v-card(outlined)
				v-card-text
					h2.font-weight-bold.body-2 Populair
					v-checkbox(v-model="request.world" hide-details)
						template(slot="label") Werelddekking
							hovertag(field="worldwide" :percentageLabel="showPercentageLabel('worldwide')")
							v-spacer
							small.ml-2(:class="{'selected': request.world}") {{ $n(getCoveragePrice('DR_GEBIED'), 'currency', $i18n.locale) }}
					v-checkbox(v-model="request.coverages" value="BR" hide-details)
						template(slot="label") Bagage
							hovertag(field="luggage" :percentageLabel="showPercentageLabel('luggage')")
							v-spacer
							small.ml-2(:class="{'selected': request.coverages.includes('BR')}") {{ $n(getCoveragePrice('BR'), 'currency', $i18n.locale) }}
					v-card.mt-2(v-if="request.coverages.includes('BR')" flat color="info")
						v-card-text
							h2.font-weight-bold.body-2 Sportartikelen
							v-checkbox(v-model="request.coverages" value="SU" hide-details)
								template(slot="label") Extra sportuitrusting
									hovertag(field="specialSportsUtilities")
									v-spacer
									small.ml-2(:class="{'selected': request.coverages.includes('SU')}") {{ $n(getCoveragePrice('SU'), 'currency', $i18n.locale) }}
					v-checkbox(v-model="request.coverages" value="OD" hide-details)
						template(slot="label") Overlijdens- of invaliditeitsuitkering
							hovertag(field="accidents" :percentageLabel="showPercentageLabel('accidents')")
							v-spacer
							small.ml-2(:class="{'selected': request.coverages.includes('OD')}") {{ $n(getCoveragePrice('OD'), 'currency', $i18n.locale) }}
					v-checkbox(v-model="request.coverages" value="AN" hide-details)
						template(slot="label") Annulering
							hovertag(field="cancellation" :percentageLabel="showPercentageLabel('cancellation')")
							v-spacer
							small.ml-2(:class="{'selected': request.coverages.includes('AN')}") {{ $n(getCoveragePrice('AN'), 'currency', $i18n.locale) }}
					v-alert.mt-2.caption(v-if="request.coverages.includes('AN')" text type="warning") Let op. De annuleringsverzekering is alleen geldig voor vakanties die na {{ $dayjs().subtract(7, 'days').format('DD-MM-YYYY') }} zijn geboekt. Is de reis langer geleden geboekt, dan zijn bestaande aandoeningen niet meeverzekerd.

					h2.font-weight-bold.body-2 Handig meeverzekerd
					v-checkbox(v-model="request.coverages" value="PH" hide-details)
						template(slot="label") Pechhulp & vervangend vervoer
							hovertag(field="carAssistance")
							v-spacer
							small.ml-2(:class="{'selected': request.coverages.includes('PH')}") {{ $n(getCoveragePrice('PH'), 'currency', $i18n.locale) }}
					v-card.mt-2(v-if="request.coverages.includes('PH')" flat color="info")
						v-card-text
							h2.font-weight-bold.body-2 Optioneel
							v-checkbox(v-model="request.PH24" true-value="J" false-value="N" hide-details)
								template(slot="label") 24-uurs-doorreisgarantie
									hovertag(field="carAssistance24")
					v-checkbox(v-model="request.coverages" value="DA" hide-details)
						template(slot="label") Zakenreizen
							hovertag(field="business")
							v-spacer
							small.ml-2(:class="{'selected': request.coverages.includes('DA')}") {{ $n(getCoveragePrice('DA'), 'currency', $i18n.locale) }}
					//- v-checkbox(v-model="request.recreatie" true-value="J" false-value="N" label="recreatie dekking" dense hide-details)
					v-checkbox(v-model="request.skileraar" true-value="J" false-value="N" hide-details)
						template(slot="label") Skileraar
							hovertag(field="instructor")
							v-spacer
							small.ml-2(:class="{'selected': request.skileraar === 'J'}") {{ $n(getCoveragePrice('DR_SKILRA'), 'currency', $i18n.locale) }}
					v-card.mt-2(v-if="request.skileraar === 'J'" flat color="info")
						v-card-text
							v-select(v-model="request.DR_SKILRA" label="Skileraar A" :items="personsArr" item-value="volgnum" item-text="name" outlined persistent-placeholder)
							v-select(v-model="request.DR_DUURA" label="Reisduur A (dagen)" :items="[90, 120, 150, 180]" outlined persistent-placeholder)
							//- v-select(v-model="request.DR_SKILRB" label="Skileraar B" :items="personsWithVolgNum" item-value="volgnum" :item-text="formatName" outlined persistent-placeholder)
							//- v-select(v-model="request.DR_DUURB" label="Reisduur B (dagen)" :items="[90, 120, 150, 180]" outlined persistent-placeholder)
				v-card-actions
					v-spacer
					v-btn(color="primary" @click="submitStep()" :disabled="isCalculating") verder naar adres- en persoonsgegevens
						v-progress-circular.ml-2(v-if="isCalculating" right indeterminate :size="15" :width="1" color="grey")

		//- STEP 3: CONTACT
		v-stepper-step(:complete="step > 3" step="3" :editable="canEditStep(3)" id="step-3")
			| Adres- en persoonsgegevens
			small
				a(v-if="canEditStep(3)" @click="step = 3") wijzig deze stap
		v-stepper-content(step="3")
			validation-observer(v-slot="{ handleSubmit, invalid }")
				v-card(outlined)
					v-card-text
						v-container.pa-0
							//- maininsured
							v-row
								v-col(cols="12")
									h2.font-weight-bold.body-2 Uw persoonsgegevens
								v-col(cols="12")
									validation-provider(name="Geslacht" rules="required" v-slot="{ errors, touched }")
										v-radio-group.mt-0.pt-0(v-model="maininsured.geslach" row hide-details="auto" :error-messages="touched ? errors : []" dense)
											v-radio(label="de heer" value="M")
											v-radio(label="mevrouw" value="V")
											//- v-radio(label="Anders" value="O")
											//- v-radio(label="Rechtspersoon" value="R")
								v-col(cols="4")
									ws-textfield(v-model="maininsured.voorl" label="Initialen" name="Initialen" rules="required")
								v-col(cols="8")
									ws-textfield(v-model="maininsured.rnaam" label="Voornaam" name="Voornaam" rules="required")
								v-col(cols="4")
									ws-textfield(v-model="maininsured.voorv" label="Tussenvoegsel" name="Tussenvoegsel")
								v-col(cols="8")
									ws-textfield(v-model="maininsured.anaam" label="Achternaam" name="Achternaam" rules="required")
								v-col(cols="12")
									p.mb-1.caption Geboortedatum
									validation-provider(name="Geboortedatum" rules="required|inpast|age:min,18" v-slot="{ errors, touched }")
										datepicker(v-model="maininsured.gebdat" maxAge="120" minAge="18")
											.caption.error--text.mb-2(v-if="errors") {{errors[0]}}
							//- partnerinsured
							v-row(v-if="request.partner")
								v-col(cols="12")
									h2.font-weight-bold.body-2 Persoonsgegevens partner
								v-col(cols="12")
									validation-provider(name="Geslacht" rules="required" v-slot="{ errors, touched }")
										v-radio-group.mt-0.pt-0(v-model="partnerinsured.geslach" row hide-details="auto" :error-messages="touched ? errors : []" dense)
											v-radio(label="de heer" value="M")
											v-radio(label="mevrouw" value="V")
											//- v-radio(label="Anders" value="O")
											//- v-radio(label="Rechtspersoon" value="R")
								v-col(cols="4")
									ws-textfield(v-model="partnerinsured.voorl" label="Initialen" name="Initialen" rules="required")
								v-col(cols="8")
									ws-textfield(v-model="partnerinsured.rnaam" label="Voornaam" name="Voornaam" rules="required")
								v-col(cols="4")
									ws-textfield(v-model="partnerinsured.voorv" label="Tussenvoegsel" name="Tussenvoegsel")
								v-col(cols="8")
									ws-textfield(v-model="partnerinsured.anaam" label="Achternaam" name="Achternaam" rules="required")
								v-col(cols="12")
									p.mb-1.caption Geboortedatum
									validation-provider(name="Geboortedatum" rules="required|inpast|age:min,18" v-slot="{ errors, touched }")
										datepicker(v-model="partnerinsured.gebdat" maxAge="120" minAge="18")
											.caption.error--text.mb-2(v-if="errors") {{errors[0]}}
							//- children
							template(v-if="childreninsured.length")
								v-row
									v-col(cols="12")
										h2.mb-6.font-weight-bold.body-2 Persoonsgegevens Kinderen
								v-card.mb-6(v-for="(child, index) in childreninsured" :key="index" outlined)
									v-card-text
										v-row
											v-col(cols="12")
												h2.mb-0.font-weight-bold.body-2 Kind {{index + 1}}
											v-col(cols="12")
												validation-provider(name="Geslacht" rules="required" v-slot="{ errors, touched }")
													v-radio-group.mt-0.pt-0(v-model="child.geslach" row hide-details="auto" :error-messages="touched ? errors : []" dense)
														v-radio(label="de heer" value="M")
														v-radio(label="mevrouw" value="V")
														//- v-radio(label="Anders" value="O")
														//- v-radio(label="Rechtspersoon" value="R")
											v-col(cols="4")
												ws-textfield(v-model="child.voorl" label="Initialen" name="Initialen" rules="required")
											v-col(cols="8")
												ws-textfield(v-model="child.rnaam" label="Voornaam" name="Voornaam" rules="required")
											v-col(cols="4")
												ws-textfield(v-model="child.voorv" label="Tussenvoegsel" name="Tussenvoegsel")
											v-col(cols="8")
												ws-textfield(v-model="child.anaam" label="Achternaam" name="Achternaam" rules="required")
											v-col(cols="12")
												p.mb-1.caption Geboortedatum
												datepicker(v-model="child.gebdat" maxAge="40" disabled)
							//- address
							v-row
								v-col(cols="12")
									h2.font-weight-bold.body-2 Uw adresgegevens
								v-col(cols="6")
									ws-textfield(v-model="maininsured.pcode" label="Postcode" name="Postcode" :rules="{ required: true, regex: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i }" @input="debouncedFetchAddress" @blur="formatPcode")
								v-col(cols="3")
									ws-textfield(v-model="maininsured.huisnr" label="Huisnummer" name="Huisnummer" rules="required|numeric" @input="debouncedFetchAddress")
								v-col(cols="3")
									ws-textfield(v-model="maininsured.toevoeg" label="Toevoeging" name="Toevoeging" rules="min:1")
								v-col(cols="6")
									validation-provider(name="Straat" :rules="{required:true, min:2}" v-slot="{ errors, touched }")
										ws-textfield(v-model="maininsured.straat" label="Straat" name="Straat" :disabled="addressLookupInProgress")
								v-col(cols="6")
									validation-provider(name="Plaats" :rules="{required:true, min:2}" v-slot="{ errors, touched }")
										ws-textfield(v-model="maininsured.plaats" label="Plaats" name="Plaats" :disabled="addressLookupInProgress")
								//- v-col(cols="12")
								//- 	ws-textfield(v-model="maininsured.land" label="Land" name="Land" rules="required")
								v-col(cols="12")
									v-alert.caption(text type="warning") Woon je niet in Nederland, dan mogen we je helaas niet accepteren voor een verzekering.
								v-col(cols="6")
									ws-textfield(v-model="maininsured.email" label="E-mailadres" name="E-mailadres" rules="required|email")
								v-col(cols="6")
									ws-textfield(v-model="maininsured.telnum" label="Telefoonnummer" name="Telefoonnummer" :rules="{required:true, length:10, numeric: true}")
								//- v-col(cols="6")
								//- 	ws-textfield(v-model="maininsured.mobiel" label="Mobiel" name="Mobiel" rules="phone")
					v-card-actions
						v-spacer
						v-btn(color="primary" depressed :disabled="invalid || isCalculating" @click="handleSubmit(submitStep)") verder naar betaalgegevens
							v-progress-circular.ml-2(v-if="isCalculating" right indeterminate :size="15" :width="1" color="grey")

		//- STEP 4: PAYMENT
		v-stepper-step(:complete="step > 4" step="4" :editable="canEditStep(4)" id="step-4")
			| Betaalgegevens
			small
				a(v-if="canEditStep(4)" @click="step = 4") wijzig deze stap
		v-stepper-content(step="4")
			validation-observer(v-slot="{ handleSubmit, invalid }")
				v-card(outlined)
					v-card-text
						h2.font-weight-bold.body-2 Uw betaalgegevens
						v-container.px-0
							v-row
								v-col(cols="12")
									ws-textfield(v-model="maininsured.iban" label="Iban" name="Iban" rules="required|iban")
					v-card-actions
						v-spacer
						v-btn(color="primary" depressed :disabled="invalid || isCalculating" @click="handleSubmit(submitStep)") verder naar aanvullende vragen
							v-progress-circular.ml-2(v-if="isCalculating" right indeterminate :size="15" :width="1" color="grey")

		//- STEP 5: QUESTIONS
		v-stepper-step(:complete="step > 5" step="5" id="step-5") Aanvullende vragen
		v-stepper-content(step="5")
			validation-observer(v-slot="{ handleSubmit, invalid }")
				v-card(outlined)
					v-card-text
						ol
							li(v-for="question in [...calculateResult.questionnaire, ...membershipResult.questionnaire]")
								p {{question.Text}}
								validation-provider(rules="required" v-slot="{ errors, touched }")
									v-radio-group(row v-model="questionResponses[question.Id]" :error-messages="touched ? errors : []")
										v-radio(:value="question.TextOk" :label="question.TextOk")
										v-radio(:value="question.TextNotOk" :label="question.TextNotOk")
								template(v-if="questionResponses[question.Id] === question.TextNotOk")
									validation-provider(rules="required" v-slot="{ errors, touched }")
										v-textarea(v-model="questionExplanations[question.Id]" label="Toelichting" name="Toelichting" outlined :error-messages="touched ? errors : []")
					v-card-actions
						v-spacer
						v-btn(color="primary" depressed :disabled="invalid || isCalculating || isRequesting" @click="handleSubmit(requestInsurance)") verzekering aanvragen
							v-progress-circular.ml-2(v-if="isRequesting" right indeterminate :size="15" :width="1" color="grey")

	//- STEP 1: CHILDREN (ADD DIALOG)
	validation-observer(v-slot="{ handleSubmit, invalid }")
		ws-dialog(v-model="showChildDialog" title="Kind toevoegen of wijzigen")
			v-container
				v-row
					v-col(cols="12")
						validation-provider(name="Geboortedatum" rules="required|inpast" v-slot="{ errors, touched }")
							datepicker(v-model="editableChild.gebdat" maxAge="40")
				v-card-actions
					v-spacer
					v-btn(color="primary" depressed :disabled="invalid" @click="handleSubmit(saveChild)") opslaan

	v-alert.flow-left(v-if="error" text type="error" id="error-msg") Er is helaas iets fout gegaan, neem contact op met de ledenservice +31 (0)30 30 77 812 op werkdagen tussen 09:00 en 17:00 uur.
</template>

<style>
.flash-enter-active {
	animation: flash-a 1.2s;
}
.flash-leave-to {
	animation: flash-r 0.8s;
}
.flash-change {
	animation: flash-a 0.8s;
}
@keyframes flash-a {
	0% {
		background-color: rgba(255, 255, 255, 0);
	}
	25% {
		background-color: rgba(46, 204, 113, 1);
	}
	100% {
		background-color: rgba(255, 255, 255, 0);
	}
}
@keyframes flash-r {
	0% {
		background-color: rgba(255, 255, 255, 0);
	}
	25% {
		background-color: rgba(231, 76, 60, 1);
	}
	100% {
		opacity: 0;
		background-color: rgba(255, 255, 255, 0);
	}
}

.selected {
	color: #2f619b;
	font-weight: 700;
}
</style>

<script>
import gql from 'graphql-tag';
import { withValidation, extend } from 'vee-validate';
import { VTextField } from 'vuetify/lib';
import dayjs from 'dayjs';
import debounce from 'lodash/debounce';
import IBAN from 'iban';
import cookies from 'js-cookie';
import Datepicker from '@/components/verzekering/datepicker.vue';
import Hovertag from '@/components/verzekering/hovertag.vue';

extend('age', {
	validate: (value, arg) => {
		if (arg[0] === 'max') {
			return dayjs().diff(value, 'years') <= parseInt(arg[1]);
		}
		if (arg[0] === 'min') {
			return dayjs().diff(value, 'years') >= parseInt(arg[1]);
		}
	},
	message: (fieldName, arg) => {
		if (arg[0] === 'max') {
			return `${fieldName} mag maximaal ${arg[1]} zijn.`;
		}
		if (arg[0] === 'min') {
			return `Bij online aanvragen moet ${fieldName} minimaal ${arg[1]} zijn. Neem contact op met de afdeling ledenservice als je jonger bent dan ${arg[1]} jaar.`;
		}
	}
});

extend('inpast', value => {
	return dayjs(value).isBefore(dayjs());
});

extend('iban', {
	validate: value => {
		// const regexes = {
		// 	// https://stackoverflow.com/questions/21928083/iban-validation-check
		// 	nl: /^NL[a-zA-Z0-9]{2}\s?([a-zA-Z]{4}\s?){1}([0-9]{4}\s?){2}([0-9]{2})\s?$/,
		// 	be: /^BE[a-zA-Z0-9]{2}\s?([0-9]{4}\s?){3}\s?$/i
		// };
		// return Object.values(regexes).some(reg => reg.test(value));
		return IBAN.isValid(value);
	},
	message: fieldName => {
		return `${fieldName} is ongeldig.`;
	}
});

const WsTextfield = withValidation(VTextField, ({ errors }) => {
	return {
		'error-messages': errors,
		outlined: true,
		placeholder: ' ',
		'persistent-placeholder': true,
		'hide-details': 'auto'
	};
});

const calculateMutation = gql`
	mutation ($request: InsuranceCalculationRequest!) {
		CalculateInsurance(request: $request) {
			questionnaire {
				Id
				Text
				TextOk
				TextNotOk
				QuestionType
			}
			coverages {
				code
				price
				price_month
			}
			coveragePrices {
				code
				price
				price_month
			}
			prices {
				total
				total_month
			}
		}
	}
`;

const calculateMembershipMutation = gql`
	mutation ($request: InsuranceCalculationMembershipRequest!) {
		CalculateMembership(request: $request) {
			questionnaire {
				Id
				Text
				TextOk
				TextNotOk
				QuestionType
			}
			coverages {
				code
				price
				price_month
			}
			prices {
				total
				total_month
			}
		}
	}
`;

const requestMutation = gql`
	mutation ($request: InsurancePolisRequest!) {
		RequestPolisInsurance(request: $request)
	}
`;

export default {
	name: 'InsuranceLongCalculate',
	components: {
		Hovertag,
		Datepicker,
		WsTextfield
	},
	nuxtI18n: {
		paths: {
			'nl-NL': '/verzekering/doorlopende-reisverzekering/afsluiten'
		}
	},
	asyncData({ app }) {
		app.ads({});
		app.meta({
			title:
				'Premie doorlopende reisverzekering berekenen - Nederlandse Ski Vereniging',
			description:
				'Bereken de premie van dé reisverzekering voor wintersporters. Voorkom problemen door een matige dekking.',
			hasFollow: true,
			hasIndex: true
		});
		app.breadcrumbs({
			[app.i18n.t('page.insurance:breadcrumb')]: { name: 'verzekering' },
			[app.i18n.t('page.insurance.travel:breadcrumb')]: {
				name: 'verzekering-doorlopend'
			},
			[app.i18n.t('page.insurance.travel.calculate:breadcrumb')]: {
				name: 'verzekering-doorlopend-calculate'
			}
		});
	},
	data() {
		return {
			error: false,
			isLoading: true,
			isCalculating: false,
			isRequesting: false,
			step: 1,
			showChildDialog: false,
			editablePerson: {},
			editablePersonIndex: -1,
			editableChild: {},
			editableChildIndex: -1,
			childrenCount: 0,
			maininsured: {},
			partnerinsured: {},
			childreninsured: [],
			questionResponses: {},
			questionExplanations: {},
			calculateResult: { questionnaire: [] },
			membershipResult: { questionnaire: [] },
			abortController: null,
			addressLookupInProgress: false,
			request: {
				GSS: 'A',
				owner: true,
				partner: false,
				children: false,
				childrenItems: [],
				world: false,
				coverages: ['ZK', 'RP', 'WS'],
				cancelAmount: '1500',
				recreatie: 'N',
				PH24: 'N',
				skileraar: 'N',
				skileraarAffiliate: null,
				DR_SKILRA: 1,
				DR_DUURA: 90
			}
		};
	},
	computed: {
		personsArr() {
			const persons = [];
			if (this.request.owner) {
				persons.push({
					name: 'Hoofdverzekerde (ikzelf)',
					volgnum: 1
				});
			}
			if (this.request.partner) {
				persons.push({
					name: 'Partner',
					volgnum: 2
				});
			}
			if (this.request.children) {
				this.request.childrenItems.forEach((_child, index) => {
					persons.push({
						name: `Kind ${index + 1}`,
						volgnum: index + 3
					});
				});
			}
			return persons;
		},
		personCount() {
			let count = 1;
			if (this.request.partner) count = 2;
			return count;
		},
		totalCalculationPrice() {
			return {
				total: (
					parseFloat(this.calculateResult.prices.total) +
					parseFloat(this.membershipResult.prices.total)
				).toFixed(2),
				total_month: (
					parseFloat(this.calculateResult.prices.total_month) +
					parseFloat(this.membershipResult.prices.total_month)
				).toFixed(2)
			};
		}
	},
	watch: {
		request: {
			deep: true,
			handler(val, old) {
				if (!val.coverages.includes('PH')) this.request.PH24 = 'N';
				// if(!val.coverages.includes('BR')) this.request.coverages = val.coverages.filter(c => c !== 'SU');
				this.calculateInsurance();
			}
		}
	},
	mounted() {
		if (cookies.get('skiinstructor-affiliate') !== undefined) {
			this.request.skileraar = 'J';
			this.request.skileraarAffiliate = cookies.get('skiinstructor-affiliate');
		}

		this.abortController = new AbortController();
		this.calculateInsurance();
	},
	methods: {
		editChild(index) {
			if (index > -1) {
				this.editableChild = { ...this.request.childrenItems[index] };
			} else {
				this.editableChild = {};
			}
			this.editableChildIndex = index;
			this.showChildDialog = true;
		},
		saveChild() {
			if (this.editableChildIndex === -1) {
				this.request.childrenItems.push({ ...this.editableChild });
				this.childreninsured.push({ ...this.editableChild });
			} else {
				this.request.childrenItems.splice(this.editableChildIndex, 1, {
					...this.editableChild
				});
				this.childreninsured.splice(this.editableChildIndex, 1, {
					...this.editableChild
				});
			}
			this.showChildDialog = false;
			this.editableChildIndex = -1;
			this.editableChild = {};
		},
		removeChild(index) {
			this.request.childrenItems.splice(index, 1);
			this.childreninsured.splice(index, 1);
		},
		canEditStep(step) {
			return this.step > step;
		},
		submitStep() {
			this.step = parseInt(this.step) + 1;
			setTimeout(() => {
				this.$vuetify.goTo(`#step-${this.step}`, {});
			}, 750);
		},
		calculateInsurance() {
			if (this.isCalculating) this.abortController.abort();
			this.abortController = new AbortController();
			const signal = this.abortController.signal;

			this.isCalculating = true;

			const insurance = this.$graphClient.mutate({
				mutation: calculateMutation,
				errorPolicy: 'all',
				variables: {
					request: { ...this.request }
				},
				context: {
					fetchOptions: {
						signal
					}
				}
			});

			let membership = null;
			if (parseInt(this.step) === 1) {
				membership = this.$graphClient.mutate({
					mutation: calculateMembershipMutation,
					errorPolicy: 'all',
					variables: {
						request: {
							owner: this.request.owner,
							partner: this.request.partner,
							children: this.request.children,
							childrenItems: this.request.childrenItems
						}
					},
					context: {
						fetchOptions: {
							signal
						}
					}
				});
			}

			Promise.all([insurance, membership]).then(result => {
				if (result && result[0]) {
					const insurance = result[0].data.CalculateInsurance;
					this.calculateResult = insurance;
				}

				if (result && result[1]) {
					const membership = result[1].data.CalculateMembership;
					this.membershipResult = membership;
				}

				this.isLoading = false;
				this.isCalculating = false;
			});
		},
		requestInsurance() {
			this.isRequesting = true;
			this.$graphClient
				.mutate({
					mutation: requestMutation,
					errorPolicy: 'all',
					variables: {
						request: {
							...this.request,
							maininsured: this.maininsured,
							...(this.request.partner && {
								partnerinsured: this.partnerinsured
							}),
							childrenItems: this.childreninsured,
							questionnaire: Object.entries(this.questionResponses).map(
								([id, response]) => {
									const result = { id, response };
									if (id in this.questionExplanations)
										result.explanation = this.questionExplanations[id];
									const question = [
										...this.calculateResult.questionnaire,
										...this.membershipResult.questionnaire
									].find(q => q.Id === id);
									if (question) result.type = question.QuestionType;
									return result;
								}
							)
						}
					}
				})
				.then(data => {
					if (!data.data.RequestPolisInsurance) this.error = true;
					if (data.data.RequestPolisInsurance) {
						this.$router.push(
							this.localePath({
								name: 'verzekering-doorlopend-thankyou'
							})
						);
					}
				})
				.catch(_e => {
					this.error = true;
					setTimeout(() => {
						this.$vuetify.goTo(`#step-5`, {});
					}, 750);
				})
				.finally(() => {
					this.step = 0;
					this.isRequesting = false;
				});
		},
		hasCoverage(coverage) {
			return this.calculateResult.coverages.some(i => {
				return i.code === coverage;
			});
		},
		getCoverage(coverage) {
			return this.calculateResult.coverages.find(i => {
				return i.code === coverage;
			});
		},
		getMembershipCoverage(coverage) {
			return this.membershipResult.coverages.find(i => {
				return i.code === coverage;
			});
		},
		getCoveragePrice(coverage) {
			if (!this.calculateResult.coveragePrices) return null;
			return this.calculateResult.coveragePrices.find(i => {
				return i.code === coverage;
			}).price_month;
		},
		showPercentageLabel(_label) {
			return false;
		},
		formatPcode() {
			if (this.maininsured.pcode)
				this.maininsured.pcode = this.maininsured.pcode
					.toUpperCase()
					.replace(/\s/g, '');
		},
		debouncedFetchAddress: debounce(function () {
			this.fetchAddress();
		}, 1500),
		fetchAddress() {
			if (!this.maininsured.pcode || !this.maininsured.huisnr) return;
			this.addressLookupInProgress = true;
			this.$graphClient
				.query({
					query: gql`
						query insuranceLookupAddress(
							$postalcode: String
							$housenumber: Int
						) {
							lookupAddress(
								postalcode: $postalcode
								housenumber: $housenumber
							) {
								postalcode
								housenumber
								street
								city
							}
						}
					`,
					variables: {
						postalcode: this.maininsured.pcode,
						housenumber: parseInt(this.maininsured.huisnr)
					},
					errorPolicy: 'all'
				})
				.then(({ data, _errors }) => {
					if (data.lookupAddress.street) {
						this.maininsured.straat = data.lookupAddress.street;
						this.maininsured.plaats = data.lookupAddress.city;
					}
					this.addressLookupInProgress = false;
				});
		}
	}
};
</script>
